export const RESOURCES = 'resources';
export const CREATIONS = 'creations';
export const SEASONS = 'seasons';
export const BADGES = 'badges';
export const VC = 'vc';
